import { css } from 'styled-components'

export const typography = {
  SmH1: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 3rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  SmH2: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 2.25rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  SmH3: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.5rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  SmH4: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.125rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  SmBody1: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.125rem;
    line-height: calc(24 / 18);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  SmBodyMed: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.125rem;
    line-height: calc(24 / 18);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  SmBody2: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1rem;
    line-height: calc(20 / 16);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  SmBody3: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 0.875rem;
    line-height: calc(18 / 14);
    font-feature-settings: 'ss05' on;
  `,
  MedH1: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 4rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  MedH2: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 3.25rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  MedH3: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.5rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  MedH4: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.125rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  MedBody1: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.125rem;
    line-height: calc(24 / 18);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  MedBody1Med: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.125rem;
    line-height: calc(24 / 18);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  MedBody2: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1rem;
    line-height: calc(20 / 16);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  MedBody3: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 0.875rem;
    line-height: calc(18 / 14);
    font-feature-settings: 'ss05' on;
  `,
  LrgH1: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 5rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  LrgH2: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 4rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  LrgH3: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 2.25rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  LrgH4: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.25rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  LrgBody1: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.25rem;
    line-height: calc(26 / 20);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  LrgBody1Med: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.25rem;
    line-height: calc(26 / 20);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  LrgBody2: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.125rem;
    line-height: calc(22 / 18);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  LrgBody3: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1rem;
    line-height: calc(20 / 16);
    font-feature-settings: 'ss05' on;
  `,
  LrgBody4: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 0.875rem;
    line-height: calc(16 / 14);
    font-feature-settings: 'ss05' on;
  `,
  XLH1: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 6.75rem;
    line-height: 94%;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  XLH2: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 4.5rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  XLH3: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 2.625rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  XLH4: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.25rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss05' on;
  `,
  XLBody1: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.25rem;
    line-height: calc(26 / 20);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  XLBody1Med: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.25rem;
    line-height: calc(26 / 20);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  XLBody2: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1.125rem;
    line-height: calc(22 / 18);
    letter-spacing: -0.01em;
    font-feature-settings: 'ss05' on;
  `,
  XLBody3: css`
    font-family: 'ABC Ginto Normal', sans-serif;
    font-size: 1rem;
    line-height: calc(20 / 16);
    font-feature-settings: 'ss05' on;
  `,
} as const
